module.exports = __webpack_public_path__ + "img/examples-ru-8.cf134f02.jpg";